"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Card = require("./Card");

var _Card2 = _interopRequireDefault(_Card);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Card2.default;